'use client';
import { ResponseBody } from '@common/types/api';
import { ElasticResponseBody } from '@common/types/elastic';

export const elasticToResponseMapper = <T>(body?: ElasticResponseBody<T>): ResponseBody<T[]> => {
  if (!body) {
    return {
      payload: [],
      total: { value: 0 },
    };
  }

  return {
    payload: body.payload.map((x) => x._source),
    total: body.total,
  };
};
